import { useDispatch, useSelector, useStore } from 'react-redux';
import store, { appReducer } from 'services/store';

export type RootState = ReturnType<typeof appReducer>;
export type AppStore = typeof store;
export type AppDispatch = AppStore['dispatch'];

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
